import React from 'react';
import BookingPolicy from '../../components/BookingPolicy/BookingPolicy';

function Info() {
  React.useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <section className="mb-12">
        <BookingPolicy />
      </section>
    </div>
  );
}

export default Info; 